module.exports = __webpack_public_path__ + "static/media/next.bbd22377.svg";